import { FC } from 'react';

import ReadingsPage from "@/components/readings/ReadingsPage";
import { Medium } from "@/constants/mediums";

const WaterReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.water} />;
};

export default WaterReadingsPage;
